import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
import {EstoqueService} from '../../services/estoque.service';

@Component({
  selector: 'app-compras-internas',
  templateUrl: './compras-internas.component.html',
  styleUrls: ['./compras-internas.component.scss']
})
export class ComprasInternasComponent implements OnInit {
  @Output() configurarUnidadesCompra = new EventEmitter<void>();

  area = 'realizados';
  catalogo: any = {insumos: []};
  catalogoCarregado = false;
  itens: any[] = [];
  itensNaoConfigurados = 0;
  filtroNovoPedido = '';
  observacoes: string;
  compras: any[] = [];
  detalhe: any;
  produtosFabrica: any[] = [];
  categoriasProdutosFabrica: string[] = [];
  produtoFabricaSelecionado: any;
  exibindoProdutosFabrica = false;
  carregandoProdutosFabrica = false;
  erroProdutosFabrica: string;
  filtroProdutosFabrica: any = {
    texto: '',
    categoria: '',
    situacao: '',
    insumo: ''
  };
  paginaProdutosFabrica = 1;
  itensPorPaginaProdutosFabrica = 20;
  filtro: any = {
    inicio: moment().subtract(30, 'days').startOf('day').toDate(),
    fim: moment().endOf('day').toDate(),
    status: null,
    codigo: null,
    texto: null
  };
  status = [
    {id: 'CRIADO', nome: 'Criado'},
    {id: 'EM_ATENDIMENTO', nome: 'Em atendimento'},
    {id: 'AGUARDANDO_RECEBIMENTO', nome: 'Aguardando recebimento'},
    {id: 'RECEBIDO', nome: 'Recebido'},
    {id: 'CANCELADO', nome: 'Cancelado'}
  ];
  carregandoCatalogo = false;
  carregandoCompras = false;
  enviando = false;
  processandoId: number;
  mensagemErro: string;
  mensagemSucesso: string;
  compraEmCancelamento: any;
  motivoCancelamento = '';
  erroCancelamento: string;
  erroRecebimento: string;

  constructor(private estoqueService: EstoqueService) {}

  ngOnInit(): void {
    this.carregueCompras();
  }

  async carregueCatalogo(): Promise<void> {
    this.carregandoCatalogo = true;
    this.mensagemErro = null;
    try {
      this.catalogo = await this.estoqueService.obtenhaCatalogoComprasInternas();
      this.catalogoCarregado = true;
      const itensCatalogo = (this.catalogo.insumos || []).map((item: any) => {
        const apresentacoes = (item.apresentacoes || [])
          .filter((apresentacao: any) => this.apresentacaoDisponivel(apresentacao));
        const apresentacaoSelecionada = apresentacoes.find((apresentacao: any) =>
          apresentacao.tipo === 'UNIDADE_COMPRA' && apresentacao.padrao
        ) || apresentacoes.find((apresentacao: any) =>
          apresentacao.tipo === 'UNIDADE_BASE'
        ) || apresentacoes[0];
        return {...item, apresentacoes, apresentacaoSelecionada, quantidade: null};
      });
      this.itensNaoConfigurados = itensCatalogo
        .filter((item: any) => !item.apresentacoes.length).length;
      this.itens = itensCatalogo.filter((item: any) => !!item.apresentacoes.length);
    } catch(erro) {
      this.mensagemErro = this.textoErro(erro);
    } finally {
      this.carregandoCatalogo = false;
    }
  }

  async carregueCompras(): Promise<void> {
    this.carregandoCompras = true;
    this.mensagemErro = null;
    try {
      const filtro: any = {};
      if(this.filtro.inicio)
        filtro.inicio = moment(this.filtro.inicio).startOf('day').toISOString();
      if(this.filtro.fim)
        filtro.fim = moment(this.filtro.fim).add(1, 'day').startOf('day').toISOString();
      if(this.filtro.status)
        filtro.status = this.filtro.status.id || this.filtro.status;
      if(this.filtro.codigo)
        filtro.codigo = this.filtro.codigo;
      if(this.filtro.texto)
        filtro.texto = this.filtro.texto;
      this.compras = await this.estoqueService.listeComprasInternas(filtro);
    } catch(erro) {
      this.mensagemErro = this.textoErro(erro);
    } finally {
      this.carregandoCompras = false;
    }
  }

  async abraProdutosFabrica(): Promise<void> {
    if(!this.catalogo.fornecimento || this.carregandoProdutosFabrica) return;
    this.exibindoProdutosFabrica = true;
    this.carregandoProdutosFabrica = true;
    this.erroProdutosFabrica = null;
    this.produtoFabricaSelecionado = null;
    this.paginaProdutosFabrica = 1;
    try {
      this.produtosFabrica = await this.estoqueService.listeProdutosFabricaCompraInterna();
      this.categoriasProdutosFabrica = Array.from(new Set<string>(
        this.produtosFabrica
          .map(produto => produto.categoria && produto.categoria.nome)
          .filter(nome => !!nome)
      )).sort((a: string, b: string) => a.localeCompare(b));
    } catch(erro) {
      this.erroProdutosFabrica = this.textoErro(erro);
    } finally {
      this.carregandoProdutosFabrica = false;
    }
  }

  fecheProdutosFabrica(): void {
    if(this.carregandoProdutosFabrica) return;
    this.exibindoProdutosFabrica = false;
  }

  produtosFabricaFiltrados(): any[] {
    const termo = this.normalizeTexto(this.filtroProdutosFabrica.texto);
    return this.produtosFabrica.filter(produto => {
      const correspondeTexto = !termo || this.normalizeTexto([
        produto.codigo,
        produto.nome,
        produto.descricao,
        produto.insumo && produto.insumo.nome,
        produto.insumo && produto.insumo.codigo
      ].filter(valor => !!valor).join(' ')).includes(termo);
      const correspondeCategoria = !this.filtroProdutosFabrica.categoria ||
        produto.categoria && produto.categoria.nome === this.filtroProdutosFabrica.categoria;
      const correspondeSituacao = !this.filtroProdutosFabrica.situacao ||
        this.statusProdutoFabrica(produto).id === this.filtroProdutosFabrica.situacao;
      const correspondeInsumo = !this.filtroProdutosFabrica.insumo ||
        (this.filtroProdutosFabrica.insumo === 'COM' && !!produto.insumo) ||
        (this.filtroProdutosFabrica.insumo === 'SEM' && !produto.insumo);
      return correspondeTexto && correspondeCategoria && correspondeSituacao && correspondeInsumo;
    });
  }

  produtosFabricaDaPagina(): any[] {
    const produtos = this.produtosFabricaFiltrados();
    const inicio = (this.paginaProdutosFabrica - 1) * this.itensPorPaginaProdutosFabrica;
    return produtos.slice(inicio, inicio + this.itensPorPaginaProdutosFabrica);
  }

  totalPaginasProdutosFabrica(): number {
    return Math.max(1, Math.ceil(
      this.produtosFabricaFiltrados().length / this.itensPorPaginaProdutosFabrica
    ));
  }

  paginasProdutosFabrica(): number[] {
    const total = this.totalPaginasProdutosFabrica();
    const inicio = Math.max(1, Math.min(this.paginaProdutosFabrica - 2, total - 4));
    const fim = Math.min(total, inicio + 4);
    const paginas: number[] = [];
    for(let pagina = inicio; pagina <= fim; pagina++) paginas.push(pagina);
    return paginas;
  }

  alterouFiltroProdutosFabrica(): void {
    this.paginaProdutosFabrica = 1;
    this.produtoFabricaSelecionado = null;
  }

  limpeFiltrosProdutosFabrica(): void {
    this.filtroProdutosFabrica = {texto: '', categoria: '', situacao: '', insumo: ''};
    this.alterouFiltroProdutosFabrica();
  }

  alterePaginaProdutosFabrica(pagina: number): void {
    if(pagina < 1 || pagina > this.totalPaginasProdutosFabrica()) return;
    this.paginaProdutosFabrica = pagina;
  }

  selecioneProdutoFabrica(produto: any): void {
    if(!produto || !produto.disponivelCompraInterna) return;
    this.produtoFabricaSelecionado = produto;
    this.erroProdutosFabrica = null;
  }

  ehProdutoFabricaSelecionado(produto: any): boolean {
    return !!(produto && this.produtoFabricaSelecionado &&
      Number(produto.id) === Number(this.produtoFabricaSelecionado.id));
  }

  confirmeProdutoFabrica(): void {
    if(!this.produtoFabricaSelecionado) return;
    let apresentacaoEncontrada: any;
    const item = this.itens.find(itemCatalogo => {
      apresentacaoEncontrada = (itemCatalogo.apresentacoes || []).find((apresentacao: any) =>
        apresentacao.vinculo && apresentacao.vinculo.produto &&
        Number(apresentacao.vinculo.produto.id) === Number(this.produtoFabricaSelecionado.id) &&
        this.apresentacaoDisponivel(apresentacao)
      );
      return !!apresentacaoEncontrada;
    });
    if(!item) {
      this.erroProdutosFabrica =
        'Este produto ainda não está vinculado a um insumo da filial disponível para compra.';
      return;
    }
    item.apresentacaoSelecionada = apresentacaoEncontrada;
    if(!Number.isInteger(Number(item.quantidade)) || Number(item.quantidade) <= 0)
      item.quantidade = 1;
    const nomeProduto = this.produtoFabricaSelecionado.nome;
    this.fecheProdutosFabrica();
    this.mensagemSucesso = `${nomeProduto} foi selecionado no pedido.`;
  }

  statusProdutoFabrica(produto: any): any {
    if(!produto || !produto.disponivelCompraInterna)
      return {id: 'NAO_ELEGIVEL', nome: 'Não elegível', classe: 'status-nao-elegivel'};
    const estoque = produto.insumo && produto.insumo.estoque;
    const atual = Number(estoque && estoque.quantidadeDisponivel);
    const minimo = Number(estoque && estoque.quantidadeMinima);
    if(Number.isFinite(atual) && Number.isFinite(minimo) && minimo > 0 && atual < minimo)
      return {id: 'ABAIXO_MINIMO', nome: 'Abaixo do mínimo', classe: 'status-abaixo-minimo'};
    return {id: 'DISPONIVEL', nome: 'Disponível', classe: 'status-disponivel'};
  }

  intervaloProdutosFabrica(): string {
    const total = this.produtosFabricaFiltrados().length;
    if(!total) return '0 resultados';
    const inicio = (this.paginaProdutosFabrica - 1) * this.itensPorPaginaProdutosFabrica + 1;
    const fim = Math.min(total, inicio + this.itensPorPaginaProdutosFabrica - 1);
    return `${inicio}–${fim} de ${total} resultados`;
  }

  exporteProdutosFabrica(): void {
    const colunas = ['Código', 'Produto', 'Descrição', 'Categoria', 'Insumo de estoque',
      'Unidade', 'Preço', 'Situação'];
    const linhas = this.produtosFabricaFiltrados().map(produto => [
      produto.codigo || '', produto.nome || '', produto.descricao || '',
      produto.categoria && produto.categoria.nome || '',
      produto.insumo && produto.insumo.nome || '',
      produto.insumo && produto.insumo.unidadeBase && produto.insumo.unidadeBase.sigla || '',
      Number(produto.preco || 0).toFixed(2), this.statusProdutoFabrica(produto).nome
    ]);
    const csv = [colunas].concat(linhas)
      .map(linha => linha.map(valor => `"${String(valor).replace(/"/g, '""')}"`).join(';'))
      .join('\n');
    const url = URL.createObjectURL(new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8;'}));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'produtos-fabrica.csv';
    link.click();
    URL.revokeObjectURL(url);
  }

  private normalizeTexto(valor: any): string {
    return String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  selecioneArea(area: string): void {
    this.area = area;
    this.mensagemErro = null;
    this.mensagemSucesso = null;
    if(area === 'realizados')
      this.carregueCompras();
    if(area === 'novo' && !this.catalogoCarregado && !this.carregandoCatalogo)
      this.carregueCatalogo();
  }

  apresentacaoDisponivel(apresentacao: any): boolean {
    return !!(apresentacao && apresentacao.status === 'VINCULADO' && apresentacao.vinculo &&
      apresentacao.vinculo.disponivel);
  }

  itemDisponivel(item: any): boolean {
    return this.apresentacaoDisponivel(item && item.apresentacaoSelecionada);
  }

  itensDoNovoPedido(): any[] {
    const termo = this.normalizeTexto(this.filtroNovoPedido);
    if(!termo) return this.itens;
    return this.itens.filter((item: any) => this.normalizeTexto([
      item.insumo && item.insumo.codigo,
      item.insumo && item.insumo.nome,
      item.apresentacaoSelecionada && item.apresentacaoSelecionada.vinculo &&
        item.apresentacaoSelecionada.vinculo.produto &&
        item.apresentacaoSelecionada.vinculo.produto.codigo,
      item.apresentacaoSelecionada && item.apresentacaoSelecionada.vinculo &&
        item.apresentacaoSelecionada.vinculo.produto &&
        item.apresentacaoSelecionada.vinculo.produto.nome
    ].filter(valor => !!valor).join(' ')).includes(termo));
  }

  quantidadeItensSelecionados(): number {
    return this.itens.filter(item => this.quantidadeValida(item)).length;
  }

  limpeNovoPedido(): void {
    this.itens.forEach(item => item.quantidade = null);
    this.observacoes = null;
    this.filtroNovoPedido = '';
    this.mensagemErro = null;
    this.mensagemSucesso = null;
  }

  estoqueAbaixoMinimo(item: any): boolean {
    const atual = Number(item && item.insumo && item.insumo.estoqueAtual);
    const minimo = Number(item && item.insumo && item.insumo.estoqueMinimo);
    return Number.isFinite(atual) && Number.isFinite(minimo) && atual < minimo;
  }

  alterouApresentacao(item: any): void {
    if(!this.itemDisponivel(item))
      item.quantidade = null;
  }

  quantidadeValida(item: any): boolean {
    const quantidade = Number(item && item.quantidade);
    return this.itemDisponivel(item) && Number.isInteger(quantidade) && quantidade > 0;
  }

  quantidadeBase(item: any): number {
    if(!this.quantidadeValida(item)) return 0;
    return Number(item.quantidade) * Number(item.apresentacaoSelecionada.fatorConversao || 0);
  }

  subtotal(item: any): number {
    if(!this.quantidadeValida(item)) return 0;
    return Number(item.quantidade) * Number(item.apresentacaoSelecionada.vinculo.produto.preco || 0);
  }

  total(): number {
    return this.itens.reduce((total: number, item: any) => total + this.subtotal(item), 0);
  }

  podeEnviar(): boolean {
    return !this.enviando && this.itens.some(item => this.quantidadeValida(item));
  }

  async envie(): Promise<void> {
    if(!this.podeEnviar()) return;
    this.enviando = true;
    this.mensagemErro = null;
    this.mensagemSucesso = null;
    try {
      const itens = this.itens.filter(item => this.quantidadeValida(item)).map(item => {
        const formaCompra = item.apresentacaoSelecionada;
        return formaCompra.tipo === 'UNIDADE_BASE' ? {
          tipo: 'UNIDADE_BASE',
          insumoId: Number(item.insumo.id),
          quantidade: Number(item.quantidade)
        } : {
          tipo: 'UNIDADE_COMPRA',
          vinculoId: Number(formaCompra.vinculo.id),
          quantidade: Number(item.quantidade)
        };
      });
      const resultado = await this.estoqueService.crieCompraInterna({
        itens,
        observacoes: this.observacoes
      });
      this.mensagemSucesso = `Pedido ${resultado.pedido.codigo} criado com sucesso.`;
      this.observacoes = null;
      this.itens.forEach(item => item.quantidade = null);
      this.area = 'realizados';
      await this.carregueCompras();
      if(resultado.resumo && !this.compras.some(compra =>
        Number(compra.id) === Number(resultado.resumo.id)))
        this.compras.unshift(resultado.resumo);
    } catch(erro) {
      this.mensagemErro = this.textoErro(erro);
    } finally {
      this.enviando = false;
    }
  }

  async abraDetalhe(compra: any): Promise<void> {
    this.processandoId = compra.id;
    this.mensagemErro = null;
    this.erroRecebimento = null;
    try {
      this.detalhe = await this.estoqueService.obtenhaCompraInterna(compra.id);
    } catch(erro) {
      this.mensagemErro = this.textoErro(erro);
    } finally {
      this.processandoId = null;
    }
  }

  fecheDetalhe(): void {
    this.detalhe = null;
    this.erroRecebimento = null;
  }

  podeCancelar(compra: any): boolean {
    return compra && compra.pedido && Number(compra.pedido.status) === 0;
  }

  podeReceber(compra: any): boolean {
    if(!compra || !compra.pedido || compra.status === 'RECEBIDO' || compra.status === 'CANCELADO')
      return false;
    const statusPedido = Number(compra.pedido.status);
    return statusPedido === 3 || statusPedido === 4;
  }

  pedidoDespachado(compra: any): boolean {
    return !!compra && !!compra.pedido && Number(compra.pedido.status) === 3;
  }

  cancele(compra: any): void {
    if(!this.podeCancelar(compra) || this.processandoId) return;
    this.compraEmCancelamento = compra;
    this.motivoCancelamento = '';
    this.erroCancelamento = null;
  }

  fecheCancelamento(): void {
    if(this.processandoId) return;
    this.compraEmCancelamento = null;
    this.motivoCancelamento = '';
    this.erroCancelamento = null;
  }

  motivoCancelamentoValido(): boolean {
    return String(this.motivoCancelamento || '').trim().length >= 5;
  }

  async confirmeCancelamento(): Promise<void> {
    const compra = this.compraEmCancelamento;
    if(!this.podeCancelar(compra) || !this.motivoCancelamentoValido() || this.processandoId)
      return;
    this.processandoId = compra.id;
    this.erroCancelamento = null;
    this.mensagemErro = null;
    this.mensagemSucesso = null;
    try {
      await this.estoqueService.canceleCompraInterna(
        compra.id,
        this.motivoCancelamento.trim()
      );
      this.mensagemSucesso = 'Compra interna cancelada.';
      this.compraEmCancelamento = null;
      this.motivoCancelamento = '';
      this.detalhe = null;
      await this.carregueCompras();
    } catch(erro) {
      this.erroCancelamento = this.textoErro(erro);
    } finally {
      this.processandoId = null;
    }
  }

  async receba(compra: any): Promise<void> {
    if(!this.podeReceber(compra) || this.processandoId) return;
    this.processandoId = compra.id;
    this.erroRecebimento = null;
    this.mensagemErro = null;
    this.mensagemSucesso = null;
    try {
      await this.estoqueService.recebaCompraInterna(compra.id);
      this.mensagemSucesso = 'Recebimento confirmado e estoque atualizado.';
      this.detalhe = null;
      await this.carregueCompras();
    } catch(erro) {
      this.erroRecebimento = this.textoErro(erro);
    } finally {
      this.processandoId = null;
    }
  }

  statusDescricao(status: string): string {
    const encontrado = this.status.find(item => item.id === status);
    return encontrado ? encontrado.nome : status;
  }

  classeStatus(status: string): string {
    if(status === 'RECEBIDO') return 'badge-success';
    if(status === 'CANCELADO') return 'badge-danger';
    if(status === 'AGUARDANDO_RECEBIMENTO') return 'badge-warning';
    if(status === 'EM_ATENDIMENTO') return 'badge-info';
    return 'badge-secondary';
  }

  private textoErro(erro: any): string {
    return typeof erro === 'string' ? erro : (erro && erro.message) || 'Não foi possível concluir a operação.';
  }
}
